"use client";

import { ArrowRight, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
const projectSpecs = [{
  label: "SERVICES WE PROVIDE",
  value: "Roofing, repairs, replacements, insurance claims"
}, {
  label: "SERVICE RADIUS",
  value: "1.5 hours from Garden City, KS"
}, {
  label: "RESPONSE TIME",
  value: "Within 48 hours"
}, {
  label: "CONSULTATION",
  value: "Free, professional on-site inspection"
}];
function BriefFormInner() {
  const {
    control,
    handleSubmit,
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    resetForm
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="relative border-4 border-primary bg-card p-10">
        <div className="absolute -top-3 -left-3 h-6 w-6 border-t-4 border-l-4 border-primary" />
        <div className="absolute -top-3 -right-3 h-6 w-6 border-t-4 border-r-4 border-primary" />
        <div className="absolute -bottom-3 -left-3 h-6 w-6 border-b-4 border-l-4 border-primary" />
        <div className="absolute -bottom-3 -right-3 h-6 w-6 border-b-4 border-r-4 border-primary" />
        <p className="font-mono text-xs uppercase mb-4 text-primary" style={{
        letterSpacing: "0.18em"
      }}>
          STATUS &#9642; REQUEST RECEIVED
        </p>
        <h3 className="font-default uppercase text-2xl md:text-3xl mb-4 text-foreground" style={{
        letterSpacing: "-0.02em",
        lineHeight: "1.0"
      }}>
          Request submitted.
        </h3>
        <p className="font-default text-base text-foreground/80 mb-6 leading-relaxed">
          {successMessage}
        </p>
        <Button type="button" onClick={resetForm} variant="outline" className="h-12 px-6 border-2 border-foreground bg-transparent text-foreground font-default uppercase hover:bg-primary hover:text-primary-foreground hover:border-primary" style={{
        letterSpacing: "0.06em"
      }}>
          Submit Another Request
        </Button>
      </div>;
  }
  return <div className="relative border-4 border-primary bg-card p-6 md:p-10">
      <div className="absolute -top-3 -left-3 h-6 w-6 border-t-4 border-l-4 border-primary" />
      <div className="absolute -top-3 -right-3 h-6 w-6 border-t-4 border-r-4 border-primary" />
      <div className="absolute -bottom-3 -left-3 h-6 w-6 border-b-4 border-l-4 border-primary" />
      <div className="absolute -bottom-3 -right-3 h-6 w-6 border-b-4 border-r-4 border-primary" />

      <Form onSubmit={handleSubmit} className="space-y-5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <FormField control={control} name="name" render={({
          field
        }) => <FormItem>
                <FormLabel className="font-mono text-xs uppercase text-foreground" style={{
            letterSpacing: "0.18em"
          }}>
                  &#9656; FULL NAME
                </FormLabel>
                <FormControl>
                  <Input placeholder="John Doe" {...field} className="h-14 border-2 border-border bg-input px-4 font-mono text-sm text-foreground placeholder:text-foreground/40 focus-visible:border-primary focus-visible:ring-0" />
                </FormControl>
                <FormMessage className="font-mono text-xs" />
              </FormItem>} />
          <FormField control={control} name="email" render={({
          field
        }) => <FormItem>
                <FormLabel className="font-mono text-xs uppercase text-foreground" style={{
            letterSpacing: "0.18em"
          }}>
                  &#9656; EMAIL ADDRESS
                </FormLabel>
                <FormControl>
                  <Input type="email" placeholder="john@example.com" {...field} className="h-14 border-2 border-border bg-input px-4 font-mono text-sm text-foreground placeholder:text-foreground/40 focus-visible:border-primary focus-visible:ring-0" />
                </FormControl>
                <FormMessage className="font-mono text-xs" />
              </FormItem>} />
        </div>

        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-xs uppercase text-foreground" style={{
          letterSpacing: "0.18em"
        }}>
                &#9656; PHONE NUMBER
                <span className="ml-2 text-foreground/50 normal-case">
                  / optional
                </span>
              </FormLabel>
              <FormControl>
                <Input type="tel" placeholder="(620) 640-0354" {...field} className="h-14 border-2 border-border bg-input px-4 font-mono text-sm text-foreground placeholder:text-foreground/40 focus-visible:border-primary focus-visible:ring-0" />
              </FormControl>
              <FormMessage className="font-mono text-xs" />
            </FormItem>} />

        <FormField control={control} name="project_type" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-xs uppercase text-foreground" style={{
          letterSpacing: "0.18em"
        }}>
                &#9656; SERVICE TYPE
              </FormLabel>
              <FormControl>
                <Select value={field.value || ""} onValueChange={field.onChange}>
                  <SelectTrigger className="h-14 w-full border-2 border-border bg-input px-4 font-mono text-sm text-foreground focus-visible:border-primary focus-visible:ring-0" style={{
              height: "3.5rem"
            }}>
                    <SelectValue placeholder="Select a service" />
                  </SelectTrigger>
                  <SelectContent className="border-2 border-border bg-popover font-mono">
                    <SelectItem value="Roof Inspection">Roof Inspection</SelectItem>
                    <SelectItem value="Roof Repair">Roof Repair</SelectItem>
                    <SelectItem value="Roof Replacement">Roof Replacement</SelectItem>
                    <SelectItem value="Storm Damage">Storm Damage Repair</SelectItem>
                    <SelectItem value="Cash Offer">Sell House Fast</SelectItem>
                  </SelectContent>
                </Select>
              </FormControl>
              <FormMessage className="font-mono text-xs" />
            </FormItem>} />

        <FormField control={control} name="brief_details" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-xs uppercase text-foreground" style={{
          letterSpacing: "0.18em"
        }}>
                &#9656; PROJECT DETAILS
              </FormLabel>
              <FormControl>
                <Textarea placeholder="Describe your roofing needs or property details..." {...field} className="min-h-40 border-2 border-border bg-input px-4 py-3 font-mono text-sm text-foreground placeholder:text-foreground/40 focus-visible:border-primary focus-visible:ring-0" />
              </FormControl>
              <FormMessage className="font-mono text-xs" />
            </FormItem>} />

        <FormField control={control} name="attachment" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-xs uppercase text-foreground" style={{
          letterSpacing: "0.18em"
        }}>
                &#9656; ATTACH PHOTOS
                <span className="ml-2 text-foreground/50 normal-case">
                  / optional
                </span>
              </FormLabel>
              <FormControl>
                <label htmlFor="brief-attachment-input" className="flex flex-col items-center justify-center w-full min-h-32 border-2 border-dashed border-primary bg-input px-6 py-8 cursor-pointer hover:bg-primary/5 transition-colors">
                  <Upload className="size-6 mb-3 text-primary" />
                  <span className="font-mono text-xs uppercase text-foreground text-center" style={{
              letterSpacing: "0.18em"
            }}>
                    &#9656; UPLOAD PROPERTY PHOTOS
                  </span>
                  <span className="font-mono text-xs text-foreground/50 mt-2">
                    PDF, JPG, or PNG up to 10 MB
                  </span>
                  <input id="brief-attachment-input" type="file" className="hidden" accept=".pdf,.jpg,.jpeg,.png" onChange={e => field.onChange(e.target.files?.[0]?.name || "")} />
                </label>
              </FormControl>
              <FormMessage className="font-mono text-xs" />
            </FormItem>} />

        {submitError && <div className="border-2 border-destructive bg-destructive/10 p-4">
            <p className="font-mono text-xs uppercase text-destructive" style={{
          letterSpacing: "0.18em"
        }}>
              &#9656; ERROR / {submitError}
            </p>
          </div>}

        <div className="pt-2">
          <Button type="submit" disabled={isSubmitting} className="group w-full h-16 bg-primary text-primary-foreground hover:bg-primary/90 font-default uppercase text-base" style={{
          letterSpacing: "0.06em",
          fontWeight: 800
        }}>
            {isSubmitting ? "SENDING..." : "REQUEST SERVICE"}
            <ArrowRight className="size-5 transition-transform group-hover:translate-x-1.5" />
          </Button>
          <p className="font-mono text-xs uppercase text-foreground/60 mt-4 text-center" style={{
          letterSpacing: "0.14em"
        }}>
            WE RESPOND WITHIN 48 HOURS / NO AUTOMATED REPLIES
          </p>
        </div>
      </Form>
    </div>;
}
export default function Inspection() {
  return <section data-section-id="1744" id="schedule-your-free-inspection" className="relative bg-background text-foreground py-24 md:py-36 overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-3.5" style={{
      backgroundImage: "repeating-linear-gradient(135deg, var(--card) 0px, var(--card) 4px, transparent 4px, transparent 8px), repeating-linear-gradient(45deg, var(--card) 0px, var(--card) 4px, transparent 4px, transparent 8px)",
      backgroundColor: "var(--secondary)"
    }} />

      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-24">
              <div className="flex items-center gap-3 mb-8">
                <p className="font-mono text-xs uppercase text-primary" style={{
                letterSpacing: "0.18em"
              }}>
                  W.O. N&deg; 01
                </p>
                <span className="inline-block w-2 h-2 bg-primary" />
                <p className="font-mono text-xs uppercase text-foreground" style={{
                letterSpacing: "0.18em"
              }}>
                  SCHEDULE SERVICE
                </p>
              </div>

              <h1 className="font-default uppercase text-foreground mb-8" style={{
              fontSize: "clamp(2.5rem, 5.5vw, 5.5rem)",
              lineHeight: "0.88",
              letterSpacing: "-0.035em",
              fontWeight: 900
            }}>
                GET A FREE{" "}
                <span className="relative inline-block">
                  <span className="relative z-10">INSPECTION</span>
                  <span aria-hidden="true" className="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-[0.18em] origin-left z-0 bg-primary" style={{
                  transform: "translateY(-50%) rotate(-6deg)"
                }} />
                </span>{" "}
                TODAY
              </h1>

              <p className="font-default text-foreground/80 mb-10 max-w-md" style={{
              fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
              lineHeight: "1.55"
            }}>
                Professional roofing services and fast cash home buying solutions. We provide reliable results with exceptional service.
              </p>

              <div className="flex items-center mb-8">
                <div className="h-px flex-1 bg-border" />
                <span className="inline-block w-1.5 h-1.5 bg-primary" />
              </div>

              <ul className="space-y-5">
                {projectSpecs.map((spec, i) => <li key={spec.label} data-index={i} className="flex items-start gap-4">
                    <span className="inline-block w-2 h-2 mt-2 shrink-0 bg-primary" />
                    <div className="flex-1">
                      <p className="font-mono text-xs uppercase text-foreground/60 mb-1" style={{
                    letterSpacing: "0.18em"
                  }}>
                        {spec.label}
                      </p>
                      <p className="font-default text-base text-foreground">
                        {spec.value}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-7">
            <FormProvider formKey="schedule_inspection_form_roofing_services" formId="schedule_inspection_form_roofing_services" sectionName="schedule-your-free-inspection" defaultValues={{
            name: "",
            email: "",
            phone: "",
            project_type: "",
            brief_details: "",
            attachment: ""
          }} validationRules={{
            name: {
              required: true,
              minLength: 2,
              maxLength: 60
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              pattern: "phone"
            },
            project_type: {
              required: true
            },
            brief_details: {
              required: true,
              minLength: 20,
              maxLength: 2000
            }
          }} submitText="Request Service" successMessage="Thanks for your request. We will review your details and contact you within 48 hours." errorMessage="Something went wrong. Please try again or call us directly.">
              <BriefFormInner />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}